<template>
    <div class="section-scene penCheng">
        <div class="line-block translate-down"></div>
        <div class="line-gold translate-left"></div>
        <img :src="static_img_url + 'pic/index/logo.png'" class="main-logo">
        <div class="content content-enter">
            <div>
                <p><img :src="static_img_url + 'pic/index/logo1.png'" class="logo-vb100"></p>
            </div>
            <div>
                <p class="gold-tle">澎橙奖</p>
            </div>
            <div>
                <p class="summary">
                    跨界，是跨界者的处方；<br>
                    创新，是创新者的徽章；<br>
                    开拓，是开拓者的权杖。
                </p>
            </div>

        </div>
        <!-- 滑块 -->
        <div class="s-postion">
            <Slider :showIcon="showIcon" :data="sliderData" :exit="exitSlider"></Slider>
        </div>
    </div>
</template>

<script>
import Slider from '../../components/slider/slider'
import { anima_mixins } from 'js/anima_mixins.js'
import { timeoutSync } from 'js/common.js'

export default {
    mixins:[anima_mixins],
    // props: {
    //     activePage: Number,
    //     nextPage: Number
    // },
    data(){
        return {
            static_img_url: process.env.VUE_APP_CDN,
            defaultPage: 6,

            showIcon: 'botton',
            exitSlider: true,
            sliderData:[
                {
                    title: '创新机构',
                    summary: `
                            <div>
                                <div style="display: inline-block;width: 50%;">
                                    <p>医疗器械投资机构</p>
                                    <p>生物医药投资机构</p>
                                    <p>医疗服务投资机构</p>
                                    <p>数字医疗投资机构</p>
                                    <p>跨界投资机构</p>
                                    <p>创新FA</p>
                                </div>
                                <div style="display: inline-block;width: 50%;position: absolute;">
                                    <p>创新产业园</p>
                                    <p>创新医院</p>
                                </div>
                            </div>
                            `,
                    url: 'http://vcbeat-vb100.mikecrm.com/1tHmQ5x'
                },
                {
                    title: '创新人物',
                    summary: 
                    `年度投资人<br>
                        年度创新医院院长<br>
                        年度创新科室主任<br>
                        年度创新企业家`,
                    url: 'http://vcbeat-vb100.mikecrm.com/jtvPPk8'
                },
                {
                    title: '创新企业类',
                    summary: `
                            年度风云企业（仅限上市企业）<br>
                            年度领袖企业<br>
                            年度创新企业<br>
                            年度潜力企业`,
                    url: 'http://vcbeat-vb100.mikecrm.com/cbPkDrl'
                }
            ]
        }
    },
    components:{
        Slider
    },
    methods: {
        async downEnter(){
            // console.log('PenCheng:下 进入')
            await timeoutSync( () => {
                $('.line-block').removeClass('translate-down')
                $('.line-gold').removeClass('translate-left')
            },100)
            await timeoutSync( () => {
                this.exitSlider = false
                $('.content').removeClass('content-enter')
                this.$emit('setLock',true)
            },600)
        },
        async upEnter(){
            // console.log('PenCheng:上 进入')
            await timeoutSync( () => {
                $('.line-block').removeClass('translate-down')
                $('.line-gold').removeClass('translate-left')
            },100)
            await timeoutSync( () => {
                this.exitSlider = false
                $('.content').removeClass('content-enter')
                this.$emit('setLock',true)
            },600)
        },

        async upLeave(){
            // console.log('PenCheng:上 退出')
            this.$emit('setLock',false)
            $('.line-block').addClass('translate-down')
            $('.line-gold').addClass('translate-left')
            $('.content').addClass('content-enter')
            this.exitSlider = true
            await timeoutSync( () => {
                this.$emit('setActivePage',this.nextPage)
            },600)
        },
        async downLeave(){
            // console.log('PenCheng:下 退出')
            this.$emit('setLock',false)
            this.exitSlider = true
            $('.line-block').addClass('translate-down')
            $('.line-gold').addClass('translate-left')
            $('.content').addClass('content-enter')
            await timeoutSync( () => {
                this.$emit('setActivePage',this.nextPage)
            },600)
        }
    }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus';
@import '~styles/animation.stylus';

.penCheng
    background #232323
    .line-block
        position absolute
        left px2vw(180)
        height 100vh
        width px2vw(100)
        background #000000
        transition all .6s
    .line-gold
        position absolute
        z-index -1
        bottom px2vw(220)
        height px2vh(80)
        width 100vw
        background linear-gradient(90deg,rgba(214,162,77,1),rgba(255,215,149,1));
        transition all .6s
    .content
        .gold-tle
            margin-top px2vh(40)
        .logo-vb100
            height px2vh(75)
        .logo-city
            margin-top px2vh(40)
            height px2vh(56)
        .summary
            margin-top px2vh(40)
            font-size:32px;
            color:#FFFFFF
            line-height:46px;
        >div
            overflow hidden
            p
                transition all .6s
        &.content-enter
            >div
                p
                    transform translateY(110%)
        @media screen and (max-width: 1366px)
            .gold-tle
                margin-top 30px
                font-size 40px !important
            .summary
                margin-top 30px
                font-size:20px;
                line-height:30px;
    .s-postion
        position absolute
        right: px2vw(250)
        top: px2vh(380)
        // @media screen and (max-width: 1600px)
        //     top: px2vh(380)




</style>